import React, { useState } from 'react';
import StatsOverlay from './StatOverlay';
import { STATSCORE_WIDGET_PREMATCH_PRO, getStatsCoreConfigurationId } from '../data/widgets/WidgetContext';

export default function StatsButton(props) {
    const [toggled, setToggled] = useState(false);

    if (props.match.id < 0) {
        return null;
    }

    function toggle() {
        setToggled(!toggled);
    }

    const prematchProEnabled = getStatsCoreConfigurationId(STATSCORE_WIDGET_PREMATCH_PRO) != null;

    if (prematchProEnabled && props.match.lsportWidgetId === 0) {
        return null;
    }

    return (
        <>
            <i className={"xs_statsButton bi-bar-chart-fill font-xs text-cs9 xs_statsButton_wh " + props.className} onClick={toggle}/>
            {toggled &&
                <StatsOverlay match={props.match} toggle={toggle} />
            }
        </>
    );
}
